import PriceRange from './price-range-directive';

import './price-range.scss';
const MODULE_NAME = 'App.Directives.PriceRange';
const module = angular
    .module(MODULE_NAME, [
        'vr.directives.slider',
    ])
    .directive('priceRange', PriceRange);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/directives/price-range/price-range-module.js